// src/utils/windowSizeHelper.ts

// Function to check if the window width is less than iPad width (768 pixels)
export const isMobileView = (): boolean => {
    if (typeof window !== "undefined") {
      return window.innerWidth < 768;
    }
    return false; // Default to false if window is not defined (e.g., during SSR)
  };
  